import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("anaiza_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const formatRON = (v) =>
  new Intl.NumberFormat("ro-RO", { style: "currency", currency: "RON", minimumFractionDigits: 2 }).format(v);

// Mirror of backend rules — must stay in sync with /app/backend/server.py
export const DISCOUNT_THRESHOLD = 500.0;
export const DISCOUNT_PERCENT = 5.0;
export const SHIPPING_COST = 19.99;

export function computeDiscount(subtotal) {
  if (subtotal >= DISCOUNT_THRESHOLD) {
    const amount = Math.round((subtotal * DISCOUNT_PERCENT) / 100 * 100) / 100;
    return { amount, percent: DISCOUNT_PERCENT, applied: true, remaining: 0 };
  }
  return { amount: 0, percent: 0, applied: false, remaining: Math.max(0, DISCOUNT_THRESHOLD - subtotal) };
}

// Returns the best applicable quantity tier for a product line, given quantity.
// tiers: [{qty: 5, percent: 5}, {qty: 10, percent: 10}, ...]
export function bestQtyTier(tiers, qty) {
  if (!tiers || !tiers.length) return { qty: 0, percent: 0 };
  const applicable = tiers.filter((t) => qty >= t.qty);
  if (!applicable.length) return { qty: 0, percent: 0 };
  return applicable.reduce((a, b) => (a.qty >= b.qty ? a : b));
}

// Next-tier hint: returns the smallest tier the user hasn't reached yet, or null
export function nextQtyTier(tiers, qty) {
  if (!tiers || !tiers.length) return null;
  const upcoming = tiers.filter((t) => qty < t.qty).sort((a, b) => a.qty - b.qty);
  return upcoming[0] || null;
}

export const CATEGORIES = [
  { slug: "cutite", title: "Cuțite Profesionale", subtitle: "Oțel japonez HRC 60 · călire laser",
    image: "https://customer-assets.emergentagent.com/job_steel-craft-depot/artifacts/z5dn9ulp_IMG_9827.jpeg" },
  { slug: "scule", title: "Truse de Scule", subtitle: "Crom-vanadium · uz profesional",
    image: "https://static.prod-images.emergentagent.com/jobs/92ec3aea-85f9-4d1a-88ef-46e63180bf5b/images/ab4fd6bae907d93ed684afe9c9ccb1b138573bba8865fd2913be1250a8221aae.png" },
];

export const HERO_BG = "https://static.prod-images.emergentagent.com/jobs/92ec3aea-85f9-4d1a-88ef-46e63180bf5b/images/18cd18bfae3b03f4bdc9d0c195dc29d7e629159b1911bb07345722084fbb0eb4.png";
